// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SUB-PAGE SLIDER (SWIPER JS)


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

$('.msdw-page-scroll').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      var offsetValue = 0;
      if ( window.innerWidth <= 767 ) {
        offsetValue;
        // console.log(offsetValue);
      } else {
        offsetValue = 59;
        // console.log(offsetValue);
      }

      $('html,body').animate({
        scrollTop: target.offset().top - offsetValue
      }, 900);
      return false;
    }
  }
});


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const scroll = window.requestAnimationFrame;

function showOnScroll() {
  const elems = document.querySelectorAll('.msdw-animate');

  elems.forEach((el) => {
    const elPosition = el.getBoundingClientRect().top
    const elScreen = window.innerHeight / 1

    if (elPosition < elScreen) {
      el.classList.add('msdw-animated')
    }
  });

  scroll(showOnScroll);
}

showOnScroll();


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

const breakpointSwitch = window.matchMedia('(min-width: 600px)');

let mySwiper;
const mobileSlider = document.querySelector('#mobileSlider');
const mobileSliderWrapper = document.querySelector('#mobileSlider .swiper-wrapper');

if (typeof(mobileSlider) != 'undefined' && mobileSlider != null) {
  const breakpointChecker = function() {
    if ( breakpointSwitch.matches === true ) {
      if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
      mobileSliderWrapper.classList.add('jwsdw-flexGrid', 'jws-grid-container', 'jws-grid-container-gutter', 'jws-padding-left-right-3', 'jws-padding-medium-left-right-4', 'jws-padding-large-left-right-5');
      return;
    } else if ( breakpointSwitch.matches === false ) {
      mobileSliderWrapper.classList.remove('jwsdw-flexGrid', 'jws-grid-container', 'jws-grid-container-gutter', 'jws-padding-left-right-3', 'jws-padding-medium-left-right-4', 'jws-padding-large-left-right-5');
      return enableSwiper();
    }
  };

  const enableSwiper = function() {
    mySwiper = new Swiper (mobileSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  };

  breakpointSwitch.addListener(breakpointChecker);

  breakpointChecker();
}


//
// =SUB-PAGE SLIDER (SWIPER JS)
// --------------------------------------------------

let workerSliderOptions = {
  slidesPerView: 1,
  loop: true,
  speed: 1,
  autoHeight: true,
  navigation: {
    nextEl: '.msdw-swiper-button-next',
    prevEl: '.msdw-swiper-button-prev',
  },
}

const workerSlider = new Swiper("#workerSlider", workerSliderOptions);

workerSlider.on('slideChange', function () {
  let nextSlide = $('.swiper-container .swiper-wrapper').children().eq( workerSlider.realIndex + 1 ).next();
  $('.msdw-slide-next').attr('src', nextSlide.find('.msdw-video-wrapper').attr('data-poster'));

  let previousSlide = $('.swiper-container .swiper-wrapper').children().eq( workerSlider.realIndex + 1 ).prev();
  $('.msdw-slide-previous').attr('src', previousSlide.find('.msdw-video-wrapper').attr('data-poster'));
});


//
// =SUB-PAGE TAB-SLIDER (SLICK JS)
// --------------------------------------------------

const sliderNav = document.querySelector('.slider-nav');

if (sliderNav) {
  $('.slider-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    infinite: false,
    variableWidth: true,
    infinite: false,
    initialSlide: 1,
    arrows: true,
    asNavFor: '.slider-for',
    focusOnSelect: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          centerMode: false,
          arrows: false,
        }
      },
    ]
  });

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 1,
    adaptiveHeight: true,
    fade: true,
    asNavFor: '.slider-nav'
  });
}

